import { useEffect } from 'react'
import SiteButton from '../../components/SiteButton'
import { useStyles } from './styles'
const SiteButtonsLayout = (props) => {
  const { sites, selected, setSelected } = props
  const classes = useStyles()

  useEffect(() => {
    setSelected(null)
  }, [sites])
  return (
    <div className={classes.layout}>
      {sites?.map((site, index) => {
        return (
          <SiteButton
            index={index}
            selectIndex={setSelected}
            selectedIndex={selected}
            siteId={site.site_id}
          ></SiteButton>
        )
      })}
    </div>
  )
}
export default SiteButtonsLayout
